// Render the MDX/MD component registered for the URL slug. Wraps the content
// in a typography class that styles headings, paragraphs, lists, tables, and
// shiki-highlighted code blocks per the docs-layout shape brief.

import { Link, useParams } from 'react-router-dom'
import { findNavItem, getDoc } from '../../docs/registry.js'

export function DocsPage() {
  const { slug } = useParams()
  const Component = getDoc(slug)
  const meta = findNavItem(slug)

  if (!Component) {
    return (
      <article>
        <h1 className="text-2xl font-semibold text-[var(--color-basalt)]">Page not found</h1>
        <p className="mt-2 text-sm text-[var(--color-schist)]">
          The doc <code className="font-mono">{slug}</code> doesn't exist.{' '}
          <Link to="/docs" className="text-[var(--color-terracotta)] hover:underline">
            Back to docs index
          </Link>
          .
        </p>
      </article>
    )
  }

  return (
    <article className="docs-content">
      {meta?.section && (
        <p className="mb-3 text-xs font-medium uppercase tracking-wider text-[var(--color-schist)]">
          {meta.section}
        </p>
      )}
      <Component />
    </article>
  )
}
